// extracted by mini-css-extract-plugin
export default {"spin-loading":"Spinner_spin-loading__oR2ki"};